export class SerialNumber {
    SerialNumber: string;
}

export default SerialNumber;